/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect, useState } from 'react'
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {  BRAND_NAME, BRAND_DESC, BRAND_NAME_ERROR, BRAND_NAME_INVALID, LABEL_BTN_CANCEL } from 'src/constants/constant';
import { InputAdornment, TextField } from '@mui/material';
import { getAllBrandById, updateBrand } from 'src/services/brandService';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import '../Styles/muiglobal.css';

import { useSelector } from 'react-redux';
import type { RootState, EditBrandFormInputs } from '../types/types';
import { checkEventPermission } from 'src/common/utility/utility';

// import MainLayout from '../Layouts/Mainlayout';

interface PropsType {
    id?: number;
}

interface PropsType {
    closeModal: () => void;
    refreshPage: () => void;
}

interface ApiResponse {
    status: number;
    data: {
        data: EditBrandFormInputs[];
    };
}

interface EditApiResponse {
    status: number;
    data: {
        result: number;
        messages: string;
    };
    
}


const validationSchema = Yup.object().shape({
     brandName: Yup.string().required(BRAND_NAME_ERROR).matches(/^[A-Za-z0-9][A-Za-z0-9 ]*$/, BRAND_NAME_INVALID),
});


const EditBrandForm = ({ id, closeModal, refreshPage }: PropsType): JSX.Element => {

    const [brandData, setBrandData] = useState<EditBrandFormInputs>()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const { user } = useSelector((state: RootState) => state.auth);
    const [isEditing, setIsEditing] = useState(false);

    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue
    } = useForm<EditBrandFormInputs>({
        resolver: yupResolver(validationSchema),
        mode: 'onSubmit',
    });

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        const fetchbrandData = async () => {
            try {
                const brandid = id;
                if (brandid == null) return;
                setIsLoading(true)
                const res: ApiResponse = await getAllBrandById(brandid);
                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                if (res.status === 200 && res.data.data.length > 0) {
                    const brand = res.data.data[0]; // Access the first brand in the array
                    setBrandData(brand);
                    
                    // Set form values
                    setValue("brandName", brand.brandName);
                    setValue("brandDescription", brand.brandDescription);
                    setValue("clientId", brand.clientId);
                }
            } catch (error) {
                console.error("Error fetching brand data:", error);
                NotificationManager.error("Error loading brand data");
            } finally {
                setIsLoading(false)
            }
        };

        void fetchbrandData();
    }, [id, setValue]);

    const onSubmit = async (data: EditBrandFormInputs): Promise<void> => {

        data.id = id;
        data.modifiedBy =  user?.id ?? 0;
        data.clientId = user?.clientId ?? 0;
        setIsLoading(true)
        await updateBrand(data)
            .then(
                (res: EditApiResponse) => {
                    if (res.status === 200 ) {
                        if(res.data.result === 1) {
                            NotificationManager.success("Brand updated successfully")
                            refreshPage()
                        } else if (res.data.messages === 'Campaign Brand was not added.') {
                            NotificationManager.error('Brand already exists');
                        } 
                        else if (res.data.messages === 'Invalid campaign brand!') {
                            NotificationManager.error('Brand already exists');
                        } 
                        else {
                            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                            NotificationManager.error("Unknown error has occurred");
                        }
                    }
                }
            )
            .catch(
                error => {
                    console.log("error", error)
                    NotificationManager.error("Unknown error has occurred")
                }
            )
            .finally(() => {
                setIsLoading(false)
            })
    }

    const handleEditBrand = ():void => {
        setIsEditing(true);
    }

    return (
        <React.Fragment>
            {
                isLoading ?
                    <div className='flex justify-center items-center relative '><span className="loading loading-spinner text-primary"></span></div> :
                    <form onSubmit={(e) => {e.preventDefault(); void handleSubmit(onSubmit)(e);}}>
                        <div className="px-[16px] pt-[10px]">
                            <div className="grid">
                                <div className={`mb-[5px] w-full relative role-input-container ${!isEditing ? 'disabled' : ''}`} style={{ marginBottom: '30px' }}>
                                    <div >
                                        <Controller
                                            name="brandName"
                                            control={control}
                                            defaultValue={brandData?.brandName}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    fullWidth
                                                    label="Brand name*"
                                                    autoComplete="off"
                                                    placeholder={BRAND_NAME}
                                                    // value={field.value}
                                                    InputProps={{
                                                        style: {
                                                            textAlign: "center",
                                                            color: '#343434',
                                                            fontSize: '18px',
                                                            fontWeight: '700',
                                                            WebkitTextFillColor: '#343434',
                                                            padding: '9px 14px 9px 25px',
                                                        },
                                                        placeholder: `${BRAND_NAME}`,
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <div className="btn btn-circle btn-circle-small bg-[#fff] hover:bg-[#f5f5f5] border-0 ml-2" style={{ padding: '4px', width: '2rem', height: '2rem', minHeight: '2rem' }} onClick={handleEditBrand}>
                                                                    <img src={'/assets/images/icons/EditIcon.svg'} width={15} height={15} alt="Edit" />
                                                                </div>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                    sx={{
                                                        '& input': {
                                                            textAlign: 'center',
                                                        },
                                                        '& label': {
                                                            textAlign: 'center',
                                                        },
                                                    }}
                                                    disabled={!isEditing}
                                                />
                                            )}
                                        />
                                        {errors.brandName && (
                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                <img src="/assets/images/attention.svg" alt="Attention" width={12} height={12} className="mr-1"/>
                                                {errors.brandName.message}
                                            </div>
                                        )}
                                    </div> 
                                </div>

                                <div className="mb-[30px]">
                                    <Controller
                                        name="brandDescription"
                                        control={control}
                                        defaultValue={brandData?.brandDescription}
                                        render={({ field }) => (
                                        <>
                                            <TextField
                                            label="Description"
                                            {...field}
                                            fullWidth
                                            autoComplete="off"
                                            InputProps={{
                                                inputProps: {
                                                style: {
                                                    textAlign: "left",
                                                    color: '#343434',
                                                    fontSize: '18px',
                                                    fontWeight: '700',
                                                    WebkitTextFillColor: '#343434',
                                                    padding: '9px 14px',
                                                },
                                                placeholder: `${BRAND_DESC}`,
                                                },
                                            }}
                                            sx={{
                                                "& label": {
                                                textAlign: "center",
                                                },
                                                backgroundColor: "#F5F5F5",
                                            }}
                                            error={!!errors.brandDescription} // Set error state based on form validation
                                            placeholder={BRAND_DESC}
                                            />
                                            {errors.brandDescription && (
                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                {errors.brandDescription?.message} 
                                            </div>
                                            )}
                                        </>
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
                            <div className="w-full relative col-span-3">
                                <button type='button' className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted" disabled={isLoading} onClick={closeModal}>{LABEL_BTN_CANCEL}</button>
                            </div>
                            <div className="w-full relative col-span-3">
                                <button type="submit" className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]" disabled={isLoading || !checkEventPermission('BRANDS_UPDATE')}>{!isLoading ? 'Save' : <span className="loading loading-spinner loading-xs text-white"></span>}</button>
                            </div>
                        </div>
                    </form>
            }
        </React.Fragment>

    )
}

export default EditBrandForm